var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(
			_vm.systemParameters.Banners && _vm.systemParameters.Banners.slides.length > 0
		)?_c('HomePageBanner'):_vm._e(),(_vm.categories && _vm.categories.length)?_c('ProductCategoryTabs',{attrs:{"carouselType":"featured"}}):_vm._e(),_c('HompageBecomeInstructor'),_c('HompageTestimonials'),(_vm.categories && _vm.categories.length)?_c('ProductCategoryTabs',{attrs:{"carouselType":"standard"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }